import * as types from "../../constants";

import * as actions from "../actions-declarations/user";
import { ActionsOf, init } from "../utils";
import { IUser } from "../../models/User";

export type UserActions = typeof actions;

export type ProfileType = {
  user: object;
  error: any
};

export type UserType = {
  user?: IUser | undefined;
  error?: any
};

export default function reducer(
  state = init<UserType>({}),
  actions: ActionsOf<UserActions>
): typeof state {
  switch (actions.type) {
    case types.USER_FETCH:
      return {
        ...state,
        user: actions.user,
      };
    case types.USER_UPDATE:
      return {
        ...state,
        user: actions.user
      }
    case types.USER_ERROR:
      return {
        ...state,
        error: actions.error
      }
    case types.CLEAR_USER_ERROR:
      return {
        ...state,
        error: undefined,
      }
    default:
      return state;
  }
}
